import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function KoppelingStatusBolletje({ size = 10 }) {
  const [status, setStatus] = useState('grijs');
  const [tip, setTip] = useState('Status laden...');

  useEffect(() => {
    let alive = true;
    const check = async () => {
      try {
        const r = await api.get('/storing-koppelingen/health');
        const ks = r.data.koppelingen || [];
        if (!alive) return;
        if (ks.length === 0) { setStatus('grijs'); setTip('Geen actieve koppelingen'); return; }
        const onlineCount = ks.filter(k => k.online).length;
        if (onlineCount === ks.length) {
          setStatus('groen');
          setTip(`Alle ${ks.length} bron(nen) bereikbaar`);
        } else if (onlineCount > 0) {
          setStatus('groen');
          const offline = ks.filter(k => !k.online).map(k => `${k.naam}: ${k.message || 'offline'}`).join('\n');
          setTip(`${onlineCount}/${ks.length} bereikbaar\nOffline:\n${offline}`);
        } else {
          setStatus('rood');
          const reasons = ks.map(k => `${k.naam}: ${k.message || 'offline'}`).join('\n');
          setTip(`Alle bronnen offline:\n${reasons}`);
        }
      } catch (e) {
        if (!alive) return;
        if (e.response?.status === 403) { setStatus('grijs'); setTip('Module niet geactiveerd'); }
        else { setStatus('grijs'); setTip('Status onbekend: ' + (e.response?.data?.message || e.message)); }
      }
    };
    check();
    const t = setInterval(check, 120000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const kleur = { groen: '#10b981', rood: '#dc2626', grijs: '#9ca3af' }[status];
  return <span title={tip} style={{ display: 'inline-block', width: size, height: size, borderRadius: '50%', background: kleur, marginLeft: 6, verticalAlign: 'middle', boxShadow: status === 'groen' ? '0 0 4px rgba(16,185,129,0.5)' : status === 'rood' ? '0 0 4px rgba(220,38,38,0.5)' : 'none' }} />;
}
